import { getCookie } from "cookies-next";
import { APIClient } from "../api/client";
import pDebounce from "p-debounce";
import axios from "axios";
import { setCookie } from "cookies-next";

const TOAST_BLACKLIST = [""];

const generateRefreshToken = pDebounce.promise(async () => {
  const response = await axios.post('/api/auth/token');
  return response.data;
});

const IS_PROD = process.env.NODE_ENV === "production";

export const handleAPIError = () => {
  APIClient.client.interceptors.response.use(
    (res) => res,
    async (err) => {
      
      const LOGIN_TOAST_FLAG = TOAST_BLACKLIST.map((i) =>
        err.config.url.includes(i)
      ).includes(true);

      if (LOGIN_TOAST_FLAG) {
        //! IGNORE THIS FLAG
      } else {
        // SHOW ERROR TOAST
      }

      const token = getCookie("token");
      if (err.response.status === 403 && token) {
        try {
          const response = await generateRefreshToken();
          console.log(response);

          if (response.accessToken) {
            setCookie("token", response.accessToken, {
              secure: IS_PROD,
              maxAge: 30 * 24 * 60 * 60,
              path: "/",
              sameSite: "lax",
            });

            const _axios = axios.create();

            return _axios.request({
              ...err.config,
              headers: {
                ...err.config.headers,
                Authorization: response.accessToken,
              },
            });
          }
        } catch (error) {
          console.log(error);
        }
      }

      return Promise.reject(err)
    }
  );
};

export const handleAPIRequest = () => {
  APIClient.client.interceptors.request.use(
    function (config) {
      // 스토리지에서 토큰을 가져온다.
      const token = getCookie("token");

      // 토큰이 있으면 요청 헤더에 추가한다.
      if (token) {
        config.headers["Authorization"] = `${token}`;
      }

      if (config.headers["Authorization"] === 'null') {
        config.headers["Authorization"] = undefined;
      }

      return config;
    },
    function (error) {
      // 요청 오류가 있는 작업 수행
      return Promise.reject(error);
    }
  );
};
